export const styles = {
  container: {
    display: "inline-flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 1.5,
    width: "fit-content",
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
  },
  badge: (badgeColor) => (theme) => ({
    width: 36,
    height: 36,
    borderRadius: "8px",
    backgroundColor: badgeColor || theme.palette.primary.main,
    color: theme.palette.common.white,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 15,
  }),
  textContainer: {
    display: "flex",
    flexDirection: "column",
  },
  title: (titleColor) => (theme) => ({
    fontWeight: 700,
    color: titleColor || theme.palette.text.primary,
    lineHeight: 1.2,
  }),
  subtitle: (theme) => ({
    color: theme.palette.text.secondary,
    mt: 0.25,
  }),
  divider: (dividerColor) => (theme) => ({
    height: 2,
    width: "100%",
    backgroundColor: dividerColor || theme.palette.divider,
    borderRadius: "1px",
  }),
}
